"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PeriodSelectionCardsContainer = exports.SubText = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.SubText = styled_components_1.default.div `
	color: ${({ theme }) => theme.color.gray7};
	margin-top: 2rem;
`;
exports.PeriodSelectionCardsContainer = styled_components_1.default.div `
	display: flex;
	justify-content: center;
	gap: 2rem;
	margin-top: 2rem;
	margin-bottom: 2rem;
	flex-wrap: wrap;
`;
